import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './Dashboard.css';

const ResetPassword = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [mensaje, setMensaje] = useState(null);
  const [error, setError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      return setError('Las contraseñas no coinciden. Inténtalo de nuevo.');
    }
    if (newPassword.length < 5) {
      return setError('La contraseña debe tener al menos 5 caracteres.');
    }

    setIsSubmitting(true);
    setError(null);
    setMensaje(null);
    const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  const apiBase = isLocal ? `http://${window.location.hostname}:3001` : `https://${window.location.hostname}`;

    try {
      const resp = await fetch(`${apiBase}/api/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, newPassword })
      });
      const data = await resp.json();
      
      if (resp.ok) {
        setMensaje(data.message);
        setTimeout(() => {
          navigate('/');
        }, 3000);
      } else {
        setError(data.error || 'Error al restablecer contraseña.');
      }
    } catch(err) {
      setError('Error de conexión con el servidor MySQL.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="modal-overlay" style={{display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f4f7fa', margin: 0, padding: 0, minHeight: '100vh', width: '100vw', position: 'fixed'}}>
      <div className="modal-content" style={{maxWidth: '450px', width: '90%', margin: 'auto', boxShadow: '0 10px 30px rgba(0,0,0,0.1)', border: 'none'}}>
        <div className="modal-header" style={{borderBottom: '1px solid #eee', paddingBottom: '15px'}}>
          <h2 style={{color: '#333', fontSize: '20px'}}>Gestor de Equipos</h2>
        </div>
        
        <div style={{padding: '20px 10px'}}>
          <h3 style={{color: '#0d6efd', marginBottom: '8px', fontSize: '22px'}}>Establecer Nueva Contraseña</h3>
          <p style={{color: '#666', fontSize: '14px', marginBottom: '25px', lineHeight: '1.5'}}>Por favor ingrese su nueva clave de acceso seguro verificando que ambos campos coincidan.</p>

          {error && <div className="error-message" style={{padding: '12px', background: '#f8d7da', color: '#721c24', borderRadius: '5px', marginBottom: '15px', fontSize: '14px', borderLeft: '4px solid #dc3545'}}>{error}</div>}
          {mensaje && <div className="error-message" style={{padding: '12px', background: '#d4edda', color: '#155724', borderRadius: '5px', marginBottom: '15px', fontSize: '14px', borderLeft: '4px solid #28a745'}}>{mensaje}</div>}
          
          <form onSubmit={handleSubmit} className="crud-form">
            <div className="form-row" style={{marginBottom: '15px'}}>
              <div className="input-group full-width">
                <label style={{fontSize: '13px', fontWeight: 'bold', color: '#555'}}>Nueva Contraseña Segura</label>
                <input 
                  type="password" 
                  value={newPassword} 
                  onChange={(e) => setNewPassword(e.target.value)} 
                  placeholder="Mínimo 5 caracteres" 
                  style={{padding: '12px', borderRadius: '6px', border: '1px solid #ccc', marginTop: '6px'}}
                  required 
                />
              </div>
            </div>
            <div className="form-row" style={{marginBottom: '30px'}}>
              <div className="input-group full-width">
                <label style={{fontSize: '13px', fontWeight: 'bold', color: '#555'}}>Confirmar la Nueva Contraseña</label>
                <input 
                  type="password" 
                  value={confirmPassword} 
                  onChange={(e) => setConfirmPassword(e.target.value)} 
                  placeholder="Escriba la clave nuevamente" 
                  style={{padding: '12px', borderRadius: '6px', border: '1px solid #ccc', marginTop: '6px'}}
                  required 
                />
              </div>
            </div>
            <div className="form-footer" style={{justifyContent: 'flex-end', marginTop: 0}}>
              <button 
                type="submit" 
                className="btn-primary" 
                disabled={isSubmitting || !!mensaje} 
                style={{background: '#20c997', border: 'none', padding: '12px 24px', width: '100%', fontSize: '15px', borderRadius: '6px'}}
              >
                {isSubmitting ? 'Verificando y Guardando...' : (mensaje ? 'Aprobado' : 'Guardar y Entrar')}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
